import { PERMANENT_COOKIE_NAME } from '@packages/domain/constants/cookies';
import { cookies } from 'utils/cookies/cookies';
import { fetchJson } from 'utils/fetchJson/fetchJson';

export const featureFlags = {
  fetch: (features: readonly string[]) => {
    const fingerprint = cookies.read(PERMANENT_COOKIE_NAME) || 'no_fingerprint';
    let queryString = features
      .map(feature => `features[]=${feature}`)
      .join('&');
    if (features && features.length) {
      queryString = `${queryString}&`;
    }

    queryString = `${queryString}fingerprint=${fingerprint}`;

    return fetchJson<Record<string, boolean>>(`/feature_flags?${queryString}`, {
      camelize: false,
    });
  },
};
